<div class="container">
  <div class="register-container">
    <div class="register-box" [ngClass]="form">
      <div class="phone-img">
        <img src="./assets/images/devs.png">
      </div>
      <div class="form-container">

        <!--Register form-->
        <div class="register-form" *ngIf="form == 'register'">
            <form [formGroup]="registerForm2" >
          <div class="title">
            <h3>{{'INDEX.REQUESTW2' | translate}}</h3>
          </div>
          <div class="daily">
            {{'INDEX.DAILY' | translate}}
          </div>
          <div class="btn-container">
            <button class="w-btn guest-btn" (click)="continueAsGuest()">{{'INDEX.GUEST' | translate}}</button>
          </div>
          <div class="or-text">
            {{'INDEX.OR' | translate}}
          </div>
          <div class="form-buttons">
            <button type="button" class="w-btn submit-btn" (click)="form = 'registerForm'">
              {{'INDEX.CREATE' | translate}}
            </button>
          </div>
          <div class="sign-box">
            {{'INDEX.ACCOUNT' | translate}} <span (click)="form = 'signin'">{{'INDEX.SIGN' | translate}}</span>
          </div>
          <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
          </form>
        </div>

          <!--Register in form -->
          <div class="register-form" *ngIf="form == 'registerForm'">
          <form [formGroup]="registerForm" >
            <div class="create">
                <h3>{{'INDEX.CREATE' | translate}}</h3>
            </div>
          <div class="input-field">
              <input type="text" name="displayName" formControlName="displayName" [title]="'INDEX.NAME' | translate"
                     [placeholder]="'INDEX.NAME' | translate">
            </div>
            <div class="input-field">
              <input type="text" name="email" formControlName="email" [title]="'INDEX.EMAIL' | translate"
                     [placeholder]="'INDEX.EMAIL' | translate">
            </div>
            <div class="input-field">
              <input type="password" name="email" formControlName="password" [title]="'INDEX.PASSWORD' | translate"
                     [placeholder]="'INDEX.PASSWORD' | translate">
            </div>
            <div class="input-field">
              <input type="text" name="phone" formControlName="phone" [title]="'INDEX.PHONE' | translate"
                     [placeholder]="'INDEX.PHONE' | translate" [textMask]="{mask: phoneMask}">
            </div>
            <div class="sign-box">
                {{'INDEX.ACCOUNT' | translate}} <span (click)="form = 'signin'">{{'INDEX.SIGN' | translate}}</span>
            </div>      
            <div class="form-buttons">
              <button type="button" class="w-btn submit-btn" (click)="submitRegisterForm(registerForm)">  <!-- form = 'verification'  to check the verification screen -->
                {{'INDEX.CREATE2' | translate}}
              </button>
            <div class="terms-text" [innerHtml]="'INDEX.TERMS' | translate"></div>
            </div>
            <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
          </form>
        </div>
                         <!-- <div class="terms-text" [innerHtml]="'INDEX.TERMS' | translate"></div>-->

           <!-- <div class="sign-box">
              {{'INDEX.ACCOUNT' | translate}} <span (click)="form = 'signin'">{{'INDEX.SIGN' | translate}}</span>
            </div>-->


          <!-- Working submit register form
            <div class="form-buttons">
              <button type="button" class="w-btn submit-btn" (click)="submitRegisterForm(registerForm)">
                {{'INDEX.CREATE' | translate}}
              </button>
            </div>-->
            
        <!--Sign in form -->
        <div class="sign-in-form" *ngIf="form == 'signin'">
          <h3>{{'INDEX.SIGN' | translate}}</h3>
          <form [formGroup]="signInForm">
            <div class="input-field">
              <input type="text" name="phone" formControlName="phone" [title]="'INDEX.PHONE' | translate"
                     [placeholder]="'INDEX.PHONE' | translate" [textMask]="{mask: phoneMask}">
            </div>
            <div class="sign-box">
              {{'INDEX.REGISTER' | translate}} <span (click)="form = 'registerForm'">{{'INDEX.CREATE' | translate}}</span>
            </div>
            <div class="form-buttons">
              <button class="w-btn submit-btn" (click)="submitSignIn(signInForm)">{{'INDEX.SIGN' | translate}}</button>
              <div class="forgot-link" (click)="forgotPassword()">
                <span>{{'INDEX.FORGOT'| translate}}</span>
              </div>
              <button class="w-btn guest-btn" (click)="continueAsGuest()">{{'INDEX.GUEST' | translate}}</button>
            </div>
            <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
          </form>
        </div>

        <!--Verification form-->
        <div class="verification-form" [hidden]="form != 'verification'">
          <h3>{{'INDEX.VERIFICATION' | translate}}</h3>
          <h5>{{'INDEX.CODE_TEXT' | translate}} +1 {{phoneVerified | phone}}</h5>
          <div class="change-number">
            <button class="w-link-btn" (click)="form = submittedForm">{{'INDEX.CHANGE' | translate}}</button>
          </div>
          <form [formGroup]="codeForm">
            <div class="input-field">
              <input type="text" name="code" formControlName="code" [title]="'INDEX.CODE' | translate"
                     [placeholder]="'INDEX.CODE' | translate" [textMask]="{mask: verificationCodeMask, guide: false}">
              <button class="w-btn submit-btn" (click)="verifySmsCode(codeForm)">{{'INDEX.VERIFY' | translate}}</button>
            </div>
            <button class="w-btn resend-btn" (click)="sendSMSVerification(phoneVerified, submittedForm)">
              {{'INDEX.RESEND' | translate}}
            </button>
            <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
          </form>
        </div>
        <div class="apple-link" *ngIf="form!='verification'">
          <a href="https://itunes.apple.com/us/app/wahii-fuel-delivery-services/id1256118132?ls=1&mt=8" target="_blank">
            <img src="./assets/svg/apple_icon.svg">
            <span>App store</span>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.wahiiuser.app" target="_blank">
            <img src="./assets/svg/g_icon.svg">
            <span>Play store</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

